'use strict';
class StickyHeader extends HTMLElement {
	constructor() {
		super();
		this.setHeaderHeight = this.setHeaderHeight.bind(this);
	}

	connectedCallback() {
		this.header = document.querySelector('.section-header');
		
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');
		this.headerFixed = this.header.getElementsByClassName('color-background-transparent');

		this.setHeaderHeight();

		if(this.headerFixed.length){
			const setTopPosition = () => { 
				this.headerTopPosition = this.header.offsetHeight;
				this.header.style.marginBottom = `-${this.header.offsetHeight}px`;
			};

			requestAnimationFrame(setTopPosition);

			this.resizeHandler = () => {
				if (this.headerResizeTimeout) {
					clearTimeout(this.headerResizeTimeout);
				}
				this.headerResizeTimeout = setTimeout(setTopPosition, 60);
			};
			
			window.addEventListener('resize', this.resizeHandler);
			document.body.classList.add('header-transparent-active');
		} 

		window.addEventListener('resize', this.setHeaderHeight);
		window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight);

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	setHeaderHeight() {
		const updateHeaderHeight = () => {
			document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
		};

		updateHeaderHeight();

		if (this.heightResizeHandler) {
			window.removeEventListener('resize', this.heightResizeHandler);
			window.removeEventListener('orientationchange', this.heightResizeHandler);
		}

		this.heightResizeHandler = () => {
			if (this.heightResizeTimeout) {
				clearTimeout(this.heightResizeTimeout);
			}
			this.heightResizeTimeout = setTimeout(updateHeaderHeight, 60);
		};

		window.addEventListener('resize', this.heightResizeHandler);
		window.addEventListener('orientationchange', this.heightResizeHandler);
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);

		if (this.resizeHandler) {
			window.removeEventListener('resize', this.resizeHandler);
		}
		
		if (this.heightResizeHandler) {
			window.removeEventListener('resize', this.heightResizeHandler);
			window.removeEventListener('orientationchange', this.heightResizeHandler);
		}

		if (this.headerResizeTimeout) {
			clearTimeout(this.headerResizeTimeout);
		}
		
		if (this.heightResizeTimeout) {
			clearTimeout(this.heightResizeTimeout);
		}

		if (this.isScrolling) {
			clearTimeout(this.isScrolling);
		}
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
			this.headerBounds = entries[0].intersectionRect;
			observer.disconnect();
		});

		observer.observe(this.header);
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			requestAnimationFrame(this.hide.bind(this));
			this.classList.add('sticky');
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerBounds.top) {
			this.classList.remove('sticky');
			requestAnimationFrame(this.reset.bind(this));
		}


		this.currentScrollTop = scrollTop;
	}

	hide() {
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
		this.closeSearchModal();
		if(this.headerFixed.length){
			this.header.style.top = "0";
		} 
	}

	reveal() {
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}
	
	reset() {
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if(this.headerFixed.length){
			this.header.style.top = " " + this.headerTopPosition + "px";
		} 
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		this.disclosures.forEach(disclosure => disclosure.close());
	}

	closeSearchModal() {
		this.searchModal = this.searchModal || this.header.querySelector('details-modal');
		if (this.searchModal) {
			this.searchModal.close(false);
		}
	}
}

customElements.define('sticky-header', StickyHeader);